<template>
  <div class="card-form">
    <PageGrid
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      :tableHeight="tableHeight"
      @reload="reload"
      @choose-change="(row) => $emit('choose-change', row)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageGrid>
  </div>
</template>

<script>
import PageHeader from './header.vue'
import PageGrid from './grid.vue'
import BaseTable from '@/mixins/base-table'

export default {
  mixins: [BaseTable],
  components: { PageHeader, PageGrid },
  props: {
    tableHeight: { type: Number, default: 500 },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomShipmentInfoListMergeApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.$emit('choose-change', null)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
